import React from 'react';
import { withFormsy } from 'formsy-react';
import { FormHelperText } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import moment from 'moment';

const format = 'DD/MM/YYYY';

export class DateInput extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      value: (this.props.value && moment(this.props.value, format)) || null
    };

    this.props.setValue(this.props.value, false);
    this.changeValue = this.changeValue.bind(this);
  }

  changeValue(event) {
    this.props.setValue(event?.format(format));
    this.setState({ value: event });
  }

  render() {
    const { name, label, required, hint, errorMessage, isPristine, startDate, endDate } = this.props;
    const isError = !isPristine && errorMessage != null;

    return (
      <div className="input-container">
        <LocalizationProvider dateAdapter={AdapterMoment}>
          <DatePicker
            slotProps={{ textField: { fullWidth: true, value: this.state.value, error: isError, required: required, 'aria-describedby': (isError ? `${name}_error` : undefined) } }}
            error={isError}
            id={name}
            name={name}
            label={label}
            onChange={this.changeValue}
            format={format}
            minDate={moment(startDate || '1900-01-01', 'YYYY-MM-DD')}
            maxDate={moment(endDate || '2100-01-01', 'YYYY-MM-DD')}
          />
        </LocalizationProvider>

        <span aria-live="polite">
          {!isPristine && errorMessage &&
            <FormHelperText id={`${name}_error`} error={isError}>{errorMessage}</FormHelperText>
          }
        </span>
        {hint &&
          <FormHelperText>{hint}</FormHelperText>
        }
      </div>
    );
  }
}

export default withFormsy(DateInput);
